import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";

import {
  useDeleteReason,
  useListReason,
  useOrderTypes,
  useReasonTypes,
  useUpdateReason,
} from "hooks/reason/useReason";
import React, { useEffect, useState } from "react";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalHeader,
  Row,
} from "reactstrap";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import ConfirmModal from "../../components/shared-components/ConfirmModal";
import RemoteDataTable from "../../components/shared-components/RemoteTable/data-table";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import ReasonForm from "./ReasonForm";
import BadgeForTable from "components/shared-components/BadgeForTable";
import { reasonRecordStatus } from "./utils";
import { selectFilter } from "react-bootstrap-table2-filter";
const ListReason = () => {
  // Get reason types from API
  const { data: reasonTypes, refetch: fetchReasonTypes } = useReasonTypes();

  // Get order types from API
  const { data: orderTypes, refetch: fetchOrderTypes } = useOrderTypes();

  const { t } = useTranslation(["reason"]);
  const [reasonParams, setReasonParams] = useState({
    page: 1,
    sizePerPage: 10,
    columnFilter: {},
    columnFilterKeep: {},
    sort: "-maker_date",
    run: false,
  });
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalActive, setOpenModalActive] = useState(false);
  const [updatingReason, setUpdatingReason] = useState(null);
  const [deletingReason, setDeletingReason] = useState(null);
  const [activeReason, setActiveReason] = useState(null);
  const [columnsTable, setColumnsTable] = useState([]);

  // Set up table columns
  const initColumns = [
    {
      dataField: "reason",
      text: t("table.reason"),
      sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        className: "form-control-sm",
        placeholder: t("placeholder.search"),
        style: { height: 34, whiteSpace: "nowrap" },
      }),
    },
    {
      dataField: "type",
      text: t("table.type"),
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.type"),
        }),
        options: reasonTypes?.reduce((acc, item) => {
          acc[item.value] = item.label;
          return acc;
        }, {}),
      }),
      formatter: (cellContent, row) => {
        return (
          reasonTypes?.find(item => item.value == row.type)?.label || row.type
        );
      },
    },
    {
      dataField: "reason_order_type",
      text: t("table.reason_order_type"),
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.reason_order_type"),
        }),
        options: orderTypes?.reduce((acc, item) => {
          acc[item.value] = item.label;
          return acc;
        }, {}),
      }),
      formatter: (cellContent, row) => {
        return (
          orderTypes?.find(item => item.value == row.reason_order_type)
            ?.label || row.reason_order_type
        );
      },
    },
    {
      dataField: "record_status",
      text: t("table.status"),
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.status"),
        }),
        options: {
          O: "Hoạt động",
          C: "Đã đóng",
        },
      }),
      formatter: (cellContent, row) => {
        return (
          <BadgeForTable
            badgeColor={
              reasonRecordStatus.find(item => item.key === row.record_status)
                .badgeColor
            }
          >
            {
              reasonRecordStatus.find(item => item.key === row.record_status)
                .name
            }
          </BadgeForTable>
        );
      },
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={reasonParams.columnFilter}
        />
      ),
    },
  ];

  // API fetch reason list
  const {
    data: reasons,
    isFetching: isLoadingReasons,
    refetch: fetchReasons,
  } = useListReason({
    params: reasonParams,
  });

  // Delete reason
  const handleDeleteSuccess = () => {
    setOpenModalDelete(false);
    setDeletingReason(null);
    fetchReasons();
  };

  const { mutate: deleteReason } = useDeleteReason(handleDeleteSuccess);

  const handleDelete = () => {
    if (deletingReason) {
      deleteReason(deletingReason.id);
    }
  };

  const handleActiveSuccess = () => {
    setOpenModalActive(false);
    setActiveReason(null);
    fetchReasons();
  };

  const { mutate: updateReason } = useUpdateReason(handleActiveSuccess);

  const handleActive = () => {
    if (activeReason) {
      updateReason({
        reasonId: activeReason.id,
        record_status: "O",
      });
    }
  };

  // Open update modal
  const handleOpenUpdateModal = reason => {
    setUpdatingReason(reason);
    setOpenModalUpdate(true);
  };

  // Open delete modal
  const handleOpenDeleteModal = reason => {
    setDeletingReason(reason);
    setOpenModalDelete(true);
  };

  const handleOpenActiveModal = reason => {
    setActiveReason(reason);
    setOpenModalActive(true);
  };

  // Handle table change

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setReasonParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : reasonParams.sort,
      columnFilter: {
        ...prev.columnFilterKeep,
        ...columnFilter,
      },
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  // Initialize data on component mount
  useEffect(() => {
    setReasonParams({
      page: 1,
      sizePerPage: 10,
      columnFilter: {},
      columnFilterKeep: {},
      sort: "-maker_date",
      run: true,
    });
    setColumnsTable(initColumns);
  }, [reasonTypes, orderTypes]);

  // Fetch data when params change
  useEffect(() => {
    if (reasonParams && reasonParams.run) {
      console.log("🚀 ~ useEffect ~ reasonParams:", reasonParams);
      fetchReasons();
    }
  }, [reasonParams]);

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("button.update"),
      onClick: handleOpenUpdateModal,
    },
    {
      icon: <i className="fas fa-trash fa-lg text-danger" />,
      text: t("button.delete"),
      onClick: handleOpenDeleteModal,
      conditionVisible: {
        record_status: ["O"],
      },
    },
    {
      icon: <i className="fas fa-check fa-lg text-success" />,
      text: t("button.active"),
      onClick: handleOpenActiveModal,
      conditionVisible: {
        record_status: ["C"],
      },
    },
  ];
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${reasons?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.reason") },
              { name: t("title.list") },
            ]}
          />

          {/* Create Modal */}
          <Modal
            size="lg"
            isOpen={openModalCreate}
            toggle={() => {
              setOpenModalCreate(false);
            }}
            centered
          >
            <ModalHeader
              toggle={() => {
                setOpenModalCreate(false);
              }}
            >
              {t("title.create")}
            </ModalHeader>
            <ReasonForm
              onSuccess={() => {
                setOpenModalCreate(false);
                fetchReasons();
              }}
            />
          </Modal>

          {/* Update Modal */}
          <Modal
            size="lg"
            isOpen={openModalUpdate}
            toggle={() => {
              setOpenModalUpdate(false);
            }}
            centered
          >
            <ModalHeader
              toggle={() => {
                setOpenModalUpdate(false);
              }}
            >
              {t("title.update")}
            </ModalHeader>
            <ReasonForm
              reason={updatingReason}
              onSuccess={() => {
                setOpenModalUpdate(false);
                fetchReasons();
              }}
            />
          </Modal>

          {/* Delete Confirmation Modal */}
          <ConfirmModal
            isOpen={openModalDelete}
            titleHeader={t("action.delete.title")}
            titleBody={`
              ${t("action.delete.description", {
                code: deletingReason?.reason,
              })} ?`}
            onConfirm={handleDelete}
            textBtnConfirm={t("button.confirm")}
            textBtnCancel={t("button.cancel")}
            toggle={() => setOpenModalDelete(false)}
          />

          {/* Active Confirmation Modal */}
          <ConfirmModal
            isOpen={openModalActive}
            titleHeader={t("action.active.title")}
            titleBody={`
              ${t("action.active.description", {
                code: activeReason?.reason,
              })} ?`}
            onConfirm={handleActive}
            textBtnConfirm={t("button.confirm")}
            textBtnCancel={t("button.cancel")}
            toggle={() => setOpenModalActive(false)}
          />

          {/* Main Content */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <RemoteDataTable
                    keyField="id"
                    data={reasons?.items || []}
                    columns={columnsTable}
                    listRowAction={listRowAction}
                    page={reasonParams.page}
                    sizePerPage={reasonParams.sizePerPage}
                    totalSize={reasons?.totalCount || 0}
                    onTableChange={handleTableChange}
                    loading={isLoadingReasons}
                  >
                    <Button
                      color="info"
                      className="btn-label"
                      type="button"
                      onClick={() => setOpenModalCreate(true)}
                      // disabled={isLoadingUpdate}
                    >
                      <i className="bx bx-plus label-icon"></i>
                      Thêm lý do
                    </Button>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListReason;
